module.exports = __webpack_public_path__ + "img/application-picture.9efb5149.svg";